import PropTypes from "prop-types";
import React, { Component } from "react";
import theme from "styles/theme";
import Badge from "material-ui/Badge";
import EditIcon from "components/icons/pencil";

/** @augments {Component<any, any>} */
class Label extends Component {
    static propTypes = {
        style: PropTypes.object,
        children: PropTypes.node,
        badge: PropTypes.number,
        editable: PropTypes.bool,
        labelStyle: PropTypes.object,
        showEditIcon: PropTypes.bool,
        className: PropTypes.string,
        dataTest: PropTypes.string,
    };

    static defaultProps = {
        style: {},
        editable: false,
        showEditIcon: true,
    };

    render() {
        const { children, style, badge, editable, labelStyle, showEditIcon, dataTest } = this.props;
        let content = null;
        let editIcon = null;

        if (editable && showEditIcon) {
            editIcon = <EditIcon style={theme.editIcon} />;
        }

        if (children) {
            content = (
                <div
                    data-test={dataTest}
                    className={this.props.className}
                    style={Object.assign({}, theme.type.label, { margin: "0 0 4px" }, style, labelStyle)}
                >
                    {children}: {editIcon}
                </div>
            );
            if (badge) {
                content = (
                    <Badge
                        badgeContent={badge}
                        badgeStyle={{
                            top: -12,
                            right: -28,
                            backgroundColor: theme.palette.lightGrey,
                            color: theme.palette.darkGrey,
                        }}
                        style={{ padding: "0px" }}
                    >
                        {content}
                    </Badge>
                );
            }
        }
        return content;
    }
}

export default Label;
